import { AxiosResponse } from 'axios';
import client from './clientRetryable';
import getRequestHeader from '@/util/getRequestHeader';

export default {
  async fetch(request: Request): Promise<AxiosResponse<Response>> {
    const response: AxiosResponse<Response> = await client.post<Response>('birth_auth', request, {
      headers: getRequestHeader()
    });
    return response;
  }
};

export interface Request {
  birthDay: string;
}

export interface Response {
  accessToken: string;
}
